module.exports = __webpack_public_path__ + "static/img/8.8ac41fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/8.svg
// module id = 703
// module chunks = 1